    import HSThemeAppearance from 'Front-Dashboard/src/assets/vendor/hs-navbar-vertical-aside/dist/hs-navbar-vertical-aside.js'
    export default {
        HSThemeAppearance:null,
        init: function() {
            window.hs_config = {
                themeAppearance: {
                    layoutSkin: 'default', // default, auto, dark
                    sidebarSkin: 'default', // default, dark, light
                    styles: {
                        colors: {
                            primary: '#377dff',
                            transparent: 'transparent',
                            white: '#fff',
                            dark: '132144',
                            gray: {
                                100: '#f9fafc',
                                900: '#1e2022'
                            }
                        },
                        font: 'Inter' // Primary Font
                    }
                }
            }
            this.HSThemeAppearance = {
                currentThemeAttributeName: 'data-hs-current-theme',
                visablilityAttributeName: 'data-hs-theme-appearance',
                init() {
                    const defaultTheme = window.hs_config.themeAppearance.layoutSkin
                    let theme = localStorage.getItem('hs_theme') || defaultTheme
                    if (theme === 'auto') {
                        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'default'
                    }
                    const $appearances = document.querySelectorAll(`[data-hs-appearance="${theme}"]`)
                    this._linkElementsAction(theme, $appearances, () => {
                        document.querySelector('[data-hs-appearance-onload-styles]').remove()
                    })
                    this._setVisablilityStyles(theme)
                },
                setAppearance(theme, saveInStore = true) {
                    const scrollTop = window.pageYOffset
                    if (saveInStore) {
                        localStorage.setItem('hs_theme', theme)
                    }
                    if (theme === 'auto') {
                        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'default'
                    }
                    const $appearances = document.querySelectorAll(`[data-hs-appearance="${theme}"]`)
                    if (!$appearances.length) {
                        return console.error(`Theme '${theme}' not found.`)
                    }
                    const $resetStyles = this._resetStylesOnLoad()
                    this._linkElementsAction(theme, $appearances, () => {
                        window.scrollTo({
                            top: scrollTop
                        })
                        this._removeOldStyleElements()
                        this._setVisablilityStyles(theme)
                        $resetStyles.remove()
                    })
                    window.dispatchEvent(new CustomEvent('on-hs-appearance-change', {
                        detail: theme
                    }))
                },
                _resetStylesOnLoad() {
                    const $resetStyles = document.createElement('style')
                    $resetStyles.innerText = `*{transition: unset !important;}body{opacity: 0 !important;}`
                    $resetStyles.setAttribute('data-hs-appearance-onload-styles', '')
                    document.head.appendChild($resetStyles)
                    return $resetStyles
                },
                _setVisablilityStyles(theme) {
                    const attrubuteName = 'data-hs-appearance-visability-styles'
                    let $style = document.querySelector(`[${attrubuteName}]`)
                    if (!$style) {
                        $style = document.createElement('style')
                        $style.setAttribute(attrubuteName, '')
                        document.head.append($style)
                    }
                    $style.textContent = `[${this.visablilityAttributeName}]:not([${this.visablilityAttributeName}='${theme}']){display:none!important;}`
                },
                _linkElementsAction(theme, appearances, callback = null) {
                    this._setOldAppearanceElements()
                    const linkElements = []
                    appearances.forEach($appearanceNode => {
                        const $link = document.createElement('link')
                        $link.setAttribute('rel', 'stylesheet')
                        $link.setAttribute('href', $appearanceNode.getAttribute('href'))
                        $link.setAttribute(this.currentThemeAttributeName, 'stylesheet')
                        document.head.insertAdjacentElement('afterEnd', $link)
                        linkElements.push($link)
                    })
                    if (callback) {
                        let loaded = 0
                        linkElements.forEach($styleNode => {
                            $styleNode.addEventListener('load', function() {
                                loaded++
                                if (loaded === linkElements.length) {
                                    return callback()
                                }
                            })
                        })
                    }
                },
                _setOldAppearanceElements() {
                    const $currentAppearanceElements = document.querySelectorAll(`[${this.currentThemeAttributeName}]`)
                    if ($currentAppearanceElements.length) {
                        $currentAppearanceElements.forEach($appearnce => $appearnce.setAttribute('data-hs-appearnce-old', true))
                    }
                },
                _removeOldStyleElements() {
                    const $oldAppearanceElements = document.querySelectorAll(`[${'data-hs-appearnce-old'}]`)
                    if ($oldAppearanceElements.length) {
                        $oldAppearanceElements.forEach($appearnce => $appearnce.remove())
                    }
                },
                getAppearance() {
                    let theme = this.getOriginalAppearance()
                    if (theme === 'auto') {
                        theme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'default'
                    }
                    return theme
                },
                getOriginalAppearance() {
                    const defaultTheme = window.hs_config.themeAppearance.layoutSkin
                    return localStorage.getItem('hs_theme') || defaultTheme
                }
            }
            this.HSThemeAppearance.init()

        },

        initToogler: function() {
            let vm=this;
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
                if (vm.HSThemeAppearance.getOriginalAppearance() === 'auto') {
                    vm.HSThemeAppearance.setAppearance('auto', false)
                }
            })
            // STYLE SWITCHER
            // =======================================================
            const $dropdownBtn = document.getElementById('selectThemeDropdown') // Dropdowon trigger
            console.log($dropdownBtn, 'aaaa');
            const $variants = document.querySelectorAll(`[aria-labelledby="selectThemeDropdown"] [data-icon]`) // All items of the dropdown
            // Function to set active style in the dorpdown menu and set icon for dropdown trigger
            const setActiveStyle = function() {
                $variants.forEach($item => {
                    if ($item.getAttribute('data-value') === vm.HSThemeAppearance.getOriginalAppearance()) {
                        $dropdownBtn.innerHTML = `<i class="${$item.getAttribute('data-icon')}" />`
                        return $item.classList.add('active')
                    }
                    $item.classList.remove('active')
                })
            }
            // Add a click event to all items of the dropdown to set the style
            $variants.forEach(function($item) {
                $item.addEventListener('click', function() {
                    vm.HSThemeAppearance.setAppearance($item.getAttribute('data-value'))
                })
            })
            // Call the setActiveStyle on load page
            setActiveStyle()
            // Add event listener on change style to call the setActiveStyle function
            window.addEventListener('on-hs-appearance-change', function() {
                setActiveStyle()
            })
        }
    }